exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep snack-bar-container.custom-class {\n  background: white; }\n\n::ng-deep .custom-class .mat-simple-snackbar {\n  color: red; }\n\n.search-add-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n.controls {\n  margin-top: 15px;\n  text-align: right;\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/main/content/users/users.component.scss
// module id = ../../../../../src/app/main/content/users/users.component.scss
// module chunks = main